{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Farbwähler",
  "colorSwatch": "Farbfeld",
  "transparent": "transparent",
  "twoDimensionalSlider": "2D-Schieberegler"
}
